import { client } from "../../../infrastructure/graphql/client";
import {
  GET_LATEST_INVOICE_ANALYSIS,
  ANALYZE_INVOICES,
} from "../../../infrastructure/graphql/aiQueries/invoiceAnalysisQueries";

export class InvoiceAnalysisService {
  async getLatestInvoiceAnalysis() {
    try {
      const result = await client.query({
        query: GET_LATEST_INVOICE_ANALYSIS,
        fetchPolicy: "network-only",
      });

      const response = result.data?.getLatestInvoiceAnalysis;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get latest invoice analysis error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async analyzeInvoices() {
    try {
      const result = await client.mutate({
        mutation: ANALYZE_INVOICES,
      });

      const response = result.data?.analyzeInvoices;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Analyze invoices error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }
}